var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen"},[_c('chat',{staticClass:"my-0 h-full",attrs:{"job":_vm.job,"conversation":_vm.conversation,"messages":_vm.messages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }